import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { InvestmentInstructionSubmissionAffectedAccount } from '../../../../models/submissions/investment-instruction-submission-affected-account';
import { AccountType } from '../../../../models/transactions/account-type';
import { AccountTypeIdEnum } from '../../../../models/enum/shared/account-type-id.enum';

@Component({
  selector: 'app-investment-instruction-submission-affected-accounts-card',
  templateUrl: './investment-instruction-submission-affected-accounts-card.component.html',
  styleUrls: ['./investment-instruction-submission-affected-accounts-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionSubmissionAffectedAccountsCardComponent implements OnChanges {
  @Input() affectedAccounts: InvestmentInstructionSubmissionAffectedAccount[] | null = [];
  @Input() accountType: AccountType | null = null;
  @Output() viewAccountClicked = new EventEmitter<InvestmentInstructionSubmissionAffectedAccount>();

  public sectionLabel: string = $localize`Defined Contribution Accounts`;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.accountType) {
      this.sectionLabel = this.resolveSectionLabel(this.accountType);
    }
  }

  public trackByAccountId(_: number, account: InvestmentInstructionSubmissionAffectedAccount): number {
    return account.accountId;
  }

  private resolveSectionLabel(accountType: AccountType | null): string {
    switch (accountType?.id) {
      case AccountTypeIdEnum.VariableBenefit:
        return $localize`Variable Benefit Accounts`;
      default:
        return $localize`Defined Contribution Accounts`;
    }
  }
}
